import React from 'react';
import './Footer.css'
const Footer = () => {
    return (

        <div className="footer">
            <p>© all right reserved Mahfuz Rahman</p>
        </div>
    );
};

export default Footer;